var _style, _g, _g2, _defs, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHazard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 55",
    style: {
      enableBackground: "new 0 0 55 55"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.7;}\n\t.st1{fill:#FCBD1B;}\n\t.st2{clip-path:url(#SVGID_2_);}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27.5,
    cy: 27.5,
    r: 26.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.5,3.2c13.4,0,24.3,10.9,24.3,24.3S40.9,51.8,27.5,51.8S3.2,40.9,3.2,27.5S14.1,3.2,27.5,3.2 M27.5,1.2 C13,1.2,1.2,13,1.2,27.5S13,53.8,27.5,53.8S53.8,42,53.8,27.5S42,1.2,27.5,1.2L27.5,1.2z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 14,
    y: 14,
    width: 27,
    height: 25
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M40.8,36.2L29.5,15.1c-0.8-1.5-3-1.5-3.8,0L14.2,36.2c-0.7,1.3,0.3,2.8,2,2.8h22.6 C40.5,39,41.5,37.5,40.8,36.2z M25.9,22.8c0-0.9,0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6v6.3c0,0.9-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6 V22.8z M25.7,33.8c0,0.9,0.7,1.6,1.6,1.6h0.5c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6h-0.5C26.4,32.2,25.7,32.9,25.7,33.8z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHazard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hazard.3028e18b39ed7b3a1c9e83175eef881d.svg";